import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const TRACTIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TractionType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const TRACTIONTYPE_CONFIG = {
  entityName: 'TractionType',
  localizationKey: 'General::Entity.TractionType',
  fields: TRACTIONTYPE_FIELDS,
  permission: 'GeneralMachinesAndVehicles.TractionTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
